export default __webpack_public_path__ + "static/media/NobelWGL-Book.7b735003.woff2";